module.exports = __webpack_public_path__ + "img/environment_119_2.18d12660.jpg";